var exports = {
  "NQ": "xa15a2ab7--0b4bc4--review",
  "Q8": "xa15a2ab7--0b4bc4--review-rate",
  "lv": "xa15a2ab7--0b4bc4--review-text",
};

module.exports = exports;
